<!-- 地图轨迹弹框组件 -->
<template>
  <div class="track-detail"
       id="moveTipsMain"
       v-if="isTrackShow">
    <div class="pop-title">
      <span>{{data.tipsTitle}}{{data.tipType>1?'（'+data.data.length+'条）':''}}</span>
      <span id="closeButton"
            class="el-icon-close close-btn"
            onClick="closeTrack()"></span>
    </div>
    <div v-if="data.tipType==1"
         class="popup-content">
      <template v-if="data.tipsAttr && data.tipsAttr.length">
        <div v-for="(item, index) in data.tipsAttr"
             :key="index"
             class="item-content">
          <label class="item-label">{{ item.label }}：</label>
          <span class="item-value"
                v-if="item.label!='照片' && item.label!='抓拍照片'">{{ item.value }}</span>
          <img v-if="item.label=='照片'"
               width="100"
               height="60"
               :src="imgPath(item.value)"
               alt
               onerror="this.src='/images/theme/newDark/default.png'" />
          <img v-if="item.label=='抓拍照片'"
               width="110"
               height="90"
               :src="data.data.face_img_url || item.value "
               alt
               onerror="this.src='/images/theme/newDark/default.png'" />
        </div>
      </template>
      <div class="footer-buttons"
           v-if="data.attr && data.attr.deviceType === '18'">
        <span class="preview-btn"
              onClick="playVideoForMapTip('live')">实时视频</span>
        <span v-if="data.upDevice"
              class="preview-btn upCoord"
              onClick="upCoordDevice('live')">更改位置</span>
      </div>
      <div class="footer-buttons"
           v-if="data.attr && (data.attr.deviceType === '25' || data.attr.deviceType === '26')">
        <span v-if="data.upDevice"
              class="preview-btn upCoord"
              style="margin-left: 0"
              onClick="upCoordDevice('live')">更改位置</span>
        <span v-if="data.openMusic"
              class="preview-btn upCoord"
              onClick="playMusic()">播放音频</span>
        <span v-if="data.openShout"
              class="preview-btn upCoord"
              onClick="remoteShout()">远程喊话</span>
        <!-- <span class="preview-btn"
              onClick="playVideoForMapTip('live')">实时视频</span> -->
      </div>
      <div class="footer-buttons"
           v-else-if="data.tipsTitle=='轨迹信息'">
        <span class="preview-btn"
              onClick="panoramicView()">查看全景</span>
        <span class="preview-btn upCoord"
              v-if="data.data.deviceType == '10' && data.data.deviceMark=='18'"
              onClick="playVideoForMapTip('back')">查看录像</span>
      </div>
      <!-- 超速配置 -->
      <div class="footer-buttons"
           v-else-if="data.attr && data.attr.flag">
        <span class="preview-btn"
              onClick="playVideoForMapTip('live')">实时视频</span>
      </div>
      <div class="footer-buttons"
           v-else-if="data.attr && data.attr.alarmId">
        <span class="preview-btn"
              onClick="playVideoForMapTip('live')">实时视频</span>
      </div>
      <div class="footer-buttons"
           v-if="data.attr && data.attr.deviceType === '19'">
        <span class="preview-btn"
              onClick="showTrail()">查询轨迹</span>
      </div>
    </div>
    <div v-if="data.tipType==2"
         class="popup-content"
         style="max-height:265px;overflow:auto;margin-bottom:15px">
      <template v-if="data.data && data.data.length>1">
        <div v-for="(item, index) in data.data"
             :key="index"
             class="item-content">
          <div>
            <img width="75"
                 height="60"
                 v-if="item.face_img_url"
                 :src="item.face_img_url"
                 alt="抓拍图片"
                 onerror="this.src='/images/theme/newDark/default.png'" />
            <img width="75"
                 height="90"
                 v-if="item.rimageUrl"
                 :src="imgPath(item.rimageUrl)"
                 alt="抓拍图片"
                 onerror="this.src='/images/theme/newDark/default.png'" />
            <img width="75"
                 height="90"
                 src="this.src='/images/theme/newDark/default.png'"
                 v-if="!item.rimageUrl && !item.face_img_url "
                 onerror="this.src='/images/theme/newDark/default.png'" />
          </div>
          <div style="margin-left:10px;color:rgb(220,225,230)">
            抓拍时间：
            <div style="margin-top:3px">{{item.recordTime4Sort || item.fullTime}}</div>
            <div v-if="item.trajectoryType == 'vehicle'"
                 style="margin-top:5px">
              <span class="mr5">车速：{{item.speed}}</span>
              <span>KM/h</span>
            </div>
            <div v-if="item.trajectoryType == 'vehicle'"
                 style="margin-top:3px">
              位置：{{item.areaName}}
            </div>
            <div>
              <el-button type="text"
                         :id="['cover_'+index]"
                         onClick="return panoramicView(this)">查看全景</el-button>
              <el-button type="text"
                         v-if="item.deviceType == '10' && item.deviceMark=='18'"
                         :id="['cover_'+index]"
                         onClick="return playVideoForMapTip('back',this)">查看录像</el-button>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div v-if="data.tipType==3"
         class="popup-content"
         style="max-height:265px;overflow:auto;margin-bottom:15px">
      <template v-if="data.data && data.data.length>1">
        <div v-for="(item, index) in data.data"
             :key="index"
             style="margin-bottom:10px"
             class="item-content">
          <div style="margin-left:10px;">
            <div style="margin-top:5px">
              {{index+1}}-
              <label class="item-label">消防车名称：</label>
              <span>{{item.deviceName}}</span>
            </div>
            <div style="margin-top:5px">
              <label class="item-label">车牌号：</label>
              <span>{{item.plateNo}}</span>
            </div>
            <div style="margin-top:3px">
              <label class="item-label"> 终端ID：</label>
              <span>{{item.thirdDeviceId}}</span>
            </div>
            <div style="margin-top:3px">
              <label class="item-label"> 状态：</label>
              <span>{{item.desc}}</span>
            </div>
            <div style="margin-top:3px">
              <label class="item-label"> 时间：</label>
              <span> {{item.satelliteTime}}</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { Bus } from "$utils";
import bus from '@/common/utils/busVue'
export default {
  components: {},
  data () {
    return {
      isShow: false,
      data: {},
      trans3d: '',
      vStyle: {
        x: 100,
        y: 100,
      },
      title: '查看全景',
      pictureShow: false,
      isTrackShow: false,
      showKey: 0
    }
  },
  created () {
    window.closeTrack = this.closeTrack;
    window.panoramicView = this.panoramicView;
    window.playVideoForMapTip = this.playVideo;
    window.upCoordDevice = this.upCoordDevice;
    window.showTrail = this.showTrail;
    window.playMusic = this.playMusic;
    window.remoteShout = this.remoteShout;
  },
  mounted () { },
  methods: {
    imgPath (item) {
      return item ? Bus.imgPath(item) : ""
    },
    closeTrack () {
      this.$emit('closeTips');
    },
    setPopData (data = {}) {
      this.isTrackShow = true
      this.data = data;
    },
    // 查看大图
    panoramicView (val) {
      if (val) {
        // 列表展示的回调
        let index = val.id.split('_')[1]
        this.$emit('pictureShow', this.data.data[index].org_img_url || this.imgPath(this.data.data[index].rimageUrl));
        return
      }
      if (this.data.tipsMap.face_img_url == '照片') {
        this.$emit('pictureShow', this.imgPath(this.data.attr.face_img_url));
      } else {
        this.$emit('pictureShow', this.data.attr.face_img_url);
      }
    },
    upCoordDevice (type = 'live') {
      console.log(this.data.attr)
      bus.$emit('upCoordDevice', this.data.attr);
      this.$emit('closeTips');
    },
    showTrail () {
      bus.$emit('showTrail', this.data.attr);
    },
    playMusic () {
      bus.$emit('playMusic', this.data.attr);
      this.$emit('closeTips');
    },
    remoteShout () {
      bus.$emit('remoteShout', this.data.attr);
      this.$emit('closeTips');
    },
    playVideo (type = 'live', val) {
      if (val) {
        // 多列气泡
        let index = val.id.split('_')[1]
        this.data.data[index].thirdDeviceId = this.data.data[index].deviceCode
        this.$emit('playVideo', type, (this.data.data[index] || {}));
      } else {
        // 单列气泡
        this.$emit('playVideo', type, (this.data.attr || {}));
      }
      this.$emit('closeTips');
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
#moveTipsMain::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: 15%;
  border-width: 10px;
  border-style: solid;
  @include set_theme_color(border-top-color, top-menu-bg-color);
  border-color: transparent transparent transparent;
}
.track-detail {
  display: flex;
  z-index: 10;
  flex-direction: column;
  @include set_theme_color(background-color, top-menu-bg-color);
  .pop-title {
    padding: 0 10px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-weight: bold;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    @include set_theme_color(background-color, table-header-bg-color);
  }
  .popup-content {
    text-align: left;
    min-width: 250px;
    font-size: 14px;
    .item-content {
      padding: 5px 0;
      margin: 5px 10px;
      display: flex;
      flex-direction: row;
    }

    .item-label {
      color: #ccc;
      width: 90px;
    }
    .item-value {
      max-width: 220px;
    }

    .item.value {
      flex: 1;
    }

    .footer-buttons {
      text-align: center;
      padding: 5px 10px;
      font-size: 14px;
      margin-bottom: 10px;
    }
  }

  .big-img {
    left: 300px;
    top: 120px;
    position: absolute;
    background: #171c28;
  }
  .bigImg-top {
    background-color: #272b37;
    height: 30px;
    line-height: 30px;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
  }
  .img-content {
    padding: 25px;
  }
  .close-btn {
    &:hover {
      @include set_theme_color(color, main-theme-color);
      cursor: pointer;
    }
    margin-top: 10px;
  }
  .track_small_content {
    display: flex;
    .track_small_img {
      flex: 1;
    }
    .track_small_img_info {
      flex: 2;
      margin-right: 10px;
      div {
        margin-top: 10px;
      }
    }
  }
  .preview-btn {
    margin-left: 10px;
    border-radius: 3px;
    @include set_theme_color(background-color, main-theme-color);
    padding: 5px 10px;
    cursor: pointer;
    color: #fff;
  }
  .preview-btn:hover {
    @include set_theme_color(background-color, active-border-color);
  }
}
</style>
